import { AREA_COLOR_MAP } from "@/shared/colors";
import type { GroupedDelayAsset } from "@/shared/repositories/DelayAssetRepository";

type AreaIds = { saws: number; welds: number };

const FALLBACK_ASSET_COLOR = "#bdbdbd";

export const toSlug = (name: string) => name.toLowerCase().replace(/\s+/g, "-");

/** the line's own color, falling back to its area's */
export const getAssetColor = (
	asset: Pick<GroupedDelayAsset, "AssetId" | "ParentAssetId">,
): string =>
	AREA_COLOR_MAP[asset.AssetId] ??
	AREA_COLOR_MAP[asset.ParentAssetId ?? 0] ??
	FALLBACK_ASSET_COLOR;

/** saws first, then welds, then the rest grouped by parent area */
export const sortAssetsByArea = <T extends GroupedDelayAsset>(
	assets: readonly T[],
	areaIds: AreaIds,
): T[] => {
	const groupOrder = (parentId: number | null) => {
		if (parentId === areaIds.saws) return 0;
		if (parentId === areaIds.welds) return 1;
		return 2;
	};
	return [...assets].sort(
		(a, b) =>
			groupOrder(a.ParentAssetId) - groupOrder(b.ParentAssetId) ||
			(a.ParentAssetId ?? 0) - (b.ParentAssetId ?? 0) ||
			a.AssetName.localeCompare(b.AssetName),
	);
};
